import { useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Loading from '../Components/Loading.jsx';
import EmailVerification from '../Components/verifyEmail.jsx';
import { Report } from '../Components/IntakeReport.jsx';
import ReportGenerating from '../Components/ReportGenerating.jsx';
import { Button } from '../Components/ui/button.tsx';

const MentalHealthReport = () => {
  const { user } = useUser();
  const { reportId } = useParams();
  const navigate = useNavigate();
  const [reportData, setReportData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!reportId) return;
      try {
        setLoading(true);
        const response = await fetch(`${import.meta.env.VITE_APP_URL ?? ''}/report/intake/${reportId}`, {
          headers: {
            Accept: 'application/json',
          },
        });

        if (response.status === 500) {
          setError({ status: 500 });
          setLoading(false);
          return;
        }

        if (!response.ok) {
          setError({ status: response.status });
          setLoading(false);
          return;
        }

        const data = await response.json();

        setReportData(data);
        setError(null);
      } catch (err) {
        setError({ status: 'error', message: err.message });
      } finally {
        setLoading(false);
      }
    };

    if (!reportId) {
      navigate('/auth/start-report');
      return;
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportId]);

  const isEmailVerified = user.emailAddresses.some((emailObj) => emailObj.verification.status === 'verified');
  if (!isEmailVerified) {
    return <EmailVerification />;
  }

  // Prevent any redirects if we have a 500 status
  if (error?.status === 500) {
    return <ReportGenerating />;
  }

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <div>Error loading report</div>;
  }

  if (!reportData) {
    return <Loading />;
  }

  return (
    <div>
      <Link to={`${reportId ? `/auth/report/${reportId}` : '/auth/start-report'}`}>
        <Button variant="ghost" className="mb-6 -ml-2 pl-2 flex items-center gap-2 text-base">
          <ArrowLeft className="h-4 w-4" />
          Back to Intake Process
        </Button>
      </Link>
      <div className="flex justify-center items-start min-h-screen bg-gray-50 px-4 py-8">
        <Report data={reportData} />
      </div>
    </div>
  );
};

export default MentalHealthReport;
